import { api } from "../../../api";

export class TicketsService {
  async fetchTicketStats() {
    return await api("/tickets/stats");
  }

  async fetchTickets({ limit, offset, search, status, priority }) {
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.toString(),
    });
    if (search) params.set("search", search);
    if (status) params.set("status", status);
    if (priority) params.set("priority", priority);
    return await api(`/tickets/?${params}`);
  }
}

export const ticketsService = new TicketsService();

// Delegators for backward compatibility / direct imports
export const fetchTicketStats = () => ticketsService.fetchTicketStats();
export const fetchTickets = (params) => ticketsService.fetchTickets(params);
